export enum WorkflowVisualizationActionType {
  WORKFLOW_VISUALIZATION_RESET = 'WORKFLOW_VISUALIZATION_RESET',
  WORKFLOW_VISUALIZATION_CLICK_NODE = 'WORKFLOW_VISUALIZATION_CLICK_NODE',
  WORKFLOW_VISUALIZATION_CLICK_LINK = 'WORKFLOW_VISUALIZATION_CLICK_LINK',
  WORKFLOW_VISUALIZATION_RIGHT_CLICK_NODE = 'WORKFLOW_VISUALIZATION_RIGHT_CLICK_NODE',
  WORKFLOW_VISUALIZATION_HOVER_NODE = 'WORKFLOW_VISUALIZATION_HOVER_NODE',
  WORKFLOW_VISUALIZATION_UNHOVER_NODE = 'WORKFLOW_VISUALIZATION_UNHOVER_NODE',
}

interface ResetAction {
  type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_RESET;
}

export function reset(): ResetAction {
  return {
    type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_RESET,
  };
}

interface ClickNodeAction {
  type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_CLICK_NODE;
  nodeId: string;
}

export function clickNode(nodeId: string): ClickNodeAction {
  return {
    type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_CLICK_NODE,
    nodeId,
  };
}

interface ClickLinkAction {
  type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_CLICK_LINK;
  parentNodeId: string | null;
  childNodeId: string | null;
}

export function clickLink(parentNodeId: string | null, childNodeId: string | null): ClickLinkAction {
  return {
    type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_CLICK_LINK,
    parentNodeId,
    childNodeId,
  };
}

interface RightClickNodeAction {
  type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_RIGHT_CLICK_NODE;
  nodeId: string | null;
}

export function rightClickNode(nodeId: string | null): RightClickNodeAction {
  return {
    type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_RIGHT_CLICK_NODE,
    nodeId,
  };
}

interface HoverNodeAction {
  type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_HOVER_NODE;
  nodeId: string;
}

export function hoverNode(nodeId: string): HoverNodeAction {
  return {
    type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_HOVER_NODE,
    nodeId,
  };
}

interface UnhoverNodeAction {
  type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_UNHOVER_NODE;
  nodeId: string;
}

export function unhoverNode(nodeId: string): UnhoverNodeAction {
  return {
    type: WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_UNHOVER_NODE,
    nodeId,
  };
}

export type WorkflowVisualizationAction =
  | ResetAction
  | ClickNodeAction
  | ClickLinkAction
  | RightClickNodeAction
  | HoverNodeAction
  | UnhoverNodeAction;
